import { z } from 'zod';

const corporateNameSchema = z
  .string()
  .trim()
  .min(1, 'Razão social é obrigatória')
  .min(3, 'Razão social deve ter pelo menos 3 caracteres')
  .max(255, 'Razão social deve ter no máximo 255 caracteres');

export default corporateNameSchema;
